module.exports = __webpack_public_path__ + "img/spritemap.84db473.svg";